function countUp(element, duration) {
  const end = parseInt(element.textContent);
  const start = 0;
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const value = Math.floor(progress * (end - start) + start);
    element.textContent = value;
    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

// Observe when the class 'visible' is added
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      const target = mutation.target;
      if (target.classList.contains('visible') && !target.dataset.animated) {
        countUp(target, 1000);
        target.dataset.animated = true; // Prevent retriggering
      }
    }
  });
});

document.querySelectorAll('[data-count-up]').forEach((counter) => {
  observer.observe(counter, { attributes: true });
});
